export function encodeSize(width, height) {
  return `${Math.ceil(width)}x${Math.ceil(height)}`;
}

export function encodeLocation(latitude, longitude) {
  return `${latitude},${longitude}`;
}

function encodeMarkerProp(key, value) {
  return `${key}:${value}`;
}

function encodeMarker({ location, ...props }) {
  const encodedProps = Object.keys(props).reduce((memo, key) => {
    const value = props[key];
    if (value != null) {
      memo.push(encodeMarkerProp(key, value));
    }
    return memo;
  }, []);
  encodedProps.push(location);
  return encodedProps.join('|');
}

function encodeParam(key, value) {
  return `${key}=${encodeURIComponent(value)}`;
}

function encodeParams({ markers, ...params }) {
  const encodedPairs = Object.keys(params).reduce((memo, key) => {
    const value = params[key];
    if (typeof value !== 'undefined') {
      memo.push(encodeParam(key, value));
    }
    return memo;
  }, []);
  if (markers) {
    encodedPairs.push(...markers.map((marker) => encodeParam('markers', encodeMarker(marker))));
  }
  return encodedPairs.join('&');
}

export function getStaticMapUrl(params) {
  return `https://maps.googleapis.com/maps/api/staticmap?${encodeParams(params)}`;
}
